import script from "./ContactSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ContactSidebar.vue?vue&type=style&index=0&id=5298cc8e&lang=scss"

const __exports__ = script;

export default __exports__